import { render, staticRenderFns } from "./table-field.vue?vue&type=template&id=dbf38a7a&"
import script from "./table-field.vue?vue&type=script&lang=js&"
export * from "./table-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports